import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ThemeProvider from "./context/ThemeContext";
import { PreferencesProvider } from "./context/PreferencesContext";
import { ConnectionModeProvider } from "./context/ConnectionModeContext";
import { installDisablePullToRefresh } from "./utils/disablePullToRefresh";

installDisablePullToRefresh();

if (
  "serviceWorker" in navigator &&
  import.meta.env.PROD
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", {
        scope: "/",
      })
      .then((registration) => {
        console.log(
          "[AVAAIO Offline] Service worker registered",
          registration.scope
        );
      })
      .catch((error) => {
        console.warn(
          "[AVAAIO Offline] Service worker registration failed",
          error
        );
      });
  });
}

document.documentElement.setAttribute("data-theme", "cyan");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <PreferencesProvider>
        <ConnectionModeProvider>
          <ThemeProvider>
              <App />
            </ThemeProvider>
        </ConnectionModeProvider>
      </PreferencesProvider>
    </BrowserRouter>
  </React.StrictMode>
);
